<template>
  <div>
    <Header state="search" />
    <div id="search-coin">
      <form>
        <div class="form-group">
          <i class="icon icon-search"></i>
          <input class="form-input input-lg" type="text" placeholder="e.g. Bitcoin, BTC" @input="search($event.target.value)">
        </div>
      </form>

      <div class="text-center" v-if="searching === true">
        <Loader />
      </div>

      <ul v-if="searching === false">
        <li v-for="coin in coins" :key="coin.id">
          <button class="card" @click="selectedExistingCoin(coin.id)">
            <div class="card-body">
              <img :src="coin.iconUrl" alt="coin logo" width="34" height="34">
              <h5>{{coin.name}}<small>({{coin.symbol}})</small></h5>
            </div>
          </button>
        </li>
        <p class="all-coins-msg text-center" v-if="coins.length === 50">
          There are plenty more coins which are not showing, please use search to find them :)
        </p>
        <li class="empty" v-if="coins.length === 0">
          <h4>Sorry, we can't find the coin</h4>
          <p>If the coin is still in ICO stage it may not appear here. Use the button below to add it for now.</p>
          <button class="btn btn-primary" @click="selectedCustomCoin">
            <i class="fa fa-plus"></i>
            <span>Custom Coin</span>
          </button>
          <p>
            <small>
              Note: make sure the coin/token code is correct.
              So we can automatically show its market price when it is added to our list later on.
            </small>
          </p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import Router from '@/router';
import Service from '@/service';
import Header from '@/components/header/Header';
import Loader from '@/components/loader/Loader';

export default {
  name: 'SearchCoin',
  components: {
    Header,
    Loader,
  },
  mounted() {
    this.requestCoinData();
  },
  data() {
    return {
      searching: true,
      coins: [],
    };
  },
  methods: {
    requestCoinData() {
      let results = [];
      Service.getAllCoinData().then((response) => {
        if (response && response.status === 'success') {
          if (response.data && response.data.coins) {
            results = response.data.coins;
          }
        }
        this.searching = false;
        this.coins = results;
      });
    },
    search(text) {
      if (text.length > 0) {
        let results = [];
        Service.searchCoin(text).then((response) => {
          if (response && response.status === 'success') {
            if (response.data && response.data.coins) {
              results = response.data.coins;
            }
          }
          this.coins = results;
        });
      } else {
        // reset list if input is empty
        this.requestCoinData();
      }
    },
    selectedExistingCoin(coinId) {
      Router.push({ name: 'AddExisting', params: { coinId } });
    },
    selectedCustomCoin() {
      Router.push({ name: 'AddCustom' });
    },
  },
};
</script>

<style lang="scss" scoped>
  #search-coin {
    margin: 1rem;

    form {
      div.form-group {
        input {
          padding: 0.2rem 0.2rem 0.2rem 1.8rem;
        }
        i {
          position: absolute;
          left: 1.5rem;
          margin-top: 0.6rem;
          z-index: 3;
          color: #BDBDBD;
        }
      }
    }

    ul {
      margin: 0;

      li {
        list-style: none;
        text-align: center;

        .card {
          border-radius: .2rem;
          width: 100%;
          cursor: pointer;

          .card-body {
            display: flex;
            flex-direction: row;
            justify-content: start;
            align-items: center;
            color: #757575;

            img {
              margin-right: 0.5rem;
            }

            h5 {
              margin-bottom: 0;

              small {
                font-size: 0.7rem;
                padding-left: 0.2rem;
              }
            }
          }
        }

        &.empty {
          button {
            width: 8rem;
            margin-bottom: 1rem;
            background-color: #673AB7;
          }
        }
      }

      .all-coins-msg {
        margin-top: 1rem;
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/view/Search.vue